const EMAIL_ISSUE_PRIORITY = {
  complained: 4,
  bounced: 3,
  suppressed: 2,
  delivery_delayed: 1,
};

const EMAIL_ISSUE_META = {
  complained: {
    label: 'Complained',
    actionLabel: 'Do not email automatically',
    tone: 'urgent',
  },
  bounced: {
    label: 'Bounced',
    actionLabel: 'Needs corrected email',
    tone: 'attention',
  },
  suppressed: {
    label: 'Suppressed',
    actionLabel: 'Needs corrected email',
    tone: 'attention',
  },
  delivery_delayed: {
    label: 'Delivery delayed',
    actionLabel: 'Temporary watch',
    tone: 'next',
  },
};

export const normalizeEmailAddress = (value) => {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  const match = raw.match(/<?([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})>?/i);
  return match?.[1] || '';
};

export const getEmailIssueMeta = (status) => EMAIL_ISSUE_META[status] || {
  label: 'Unknown issue',
  actionLabel: 'Review email health',
  tone: 'steady',
};

export const buildEmailIssueLookup = (issues = []) => {
  const lookup = new Map();

  issues.forEach((issue) => {
    const email = normalizeEmailAddress(issue?.email);
    if (!email) return;

    const existing = lookup.get(email);
    const existingPriority = EMAIL_ISSUE_PRIORITY[existing?.latest_status] || 0;
    const issuePriority = EMAIL_ISSUE_PRIORITY[issue?.latest_status] || 0;
    const existingTime = existing?.latest_issue_at ? new Date(existing.latest_issue_at).getTime() : 0;
    const issueTime = issue?.latest_issue_at ? new Date(issue.latest_issue_at).getTime() : 0;

    if (!existing || issuePriority > existingPriority || (issuePriority === existingPriority && issueTime >= existingTime)) {
      lookup.set(email, issue);
    }
  });

  return lookup;
};

export const collectEmailIssuesForPeople = (people = [], getEmail) => {
  const issues = people
    .map((person) => {
      const issue = getEmail(person);
      if (!issue) return null;
      return {
        person,
        issue,
        meta: getEmailIssueMeta(issue.latest_status),
      };
    })
    .filter(Boolean);

  issues.sort((a, b) => {
    const priorityDiff = (EMAIL_ISSUE_PRIORITY[b.issue?.latest_status] || 0) - (EMAIL_ISSUE_PRIORITY[a.issue?.latest_status] || 0);
    if (priorityDiff !== 0) return priorityDiff;

    const aTime = a.issue?.latest_issue_at ? new Date(a.issue.latest_issue_at).getTime() : 0;
    const bTime = b.issue?.latest_issue_at ? new Date(b.issue.latest_issue_at).getTime() : 0;
    return bTime - aTime;
  });

  return issues;
};

export const summarizeEmailIssueGroups = (issues = []) => {
  const groups = {
    needsCorrection: 0,
    doNotEmail: 0,
    temporaryWatch: 0,
  };

  issues.forEach(({ issue }) => {
    switch (issue?.latest_status) {
      case 'complained':
        groups.doNotEmail += 1;
        break;
      case 'bounced':
      case 'suppressed':
        groups.needsCorrection += 1;
        break;
      case 'delivery_delayed':
        groups.temporaryWatch += 1;
        break;
      default:
        break;
    }
  });

  return groups;
};
